module.exports = __webpack_public_path__ + "static/euclids-elements-f56c789dd4c6eba271448fdf0584b8d6.jpg";